export default __webpack_public_path__ + "static/media/water-sub-meter-icon.7ab563ad.svg";